import RolexClock from './rolex-clock'

export default RolexClock
